import React, {useEffect} from "react";
import {Card, Col, Form, OverlayTrigger, Tooltip} from "react-bootstrap";
import genericStyles from "../styles/SingleProcess.module.css";
import InputMask from "react-input-mask";
import {findAllRetirementType} from "../../../../services/RequestService";
import Select from 'react-select';


function getFormattedDate(date) {
  if (date === null || date === undefined) {
    return "Não possuí´";
  } else {
    let cdDate = new Date(date);
    return cdDate.toLocaleDateString("pt-BR");
  }
}

function RenderInput({name, label, value, disabled, colProps, options, type, onChange, ...props}) {
  // Monta o objeto {value, label} que o react-select espera
  const selectValue = options
    ? (options.find(o => String(o.value) === String(value)) || null)
    : null;

  // Adapta o onChange do react-select para o formato nativo {target: {name, value}}
  const handleSelectChange = (selected) => {
    onChange?.({target: {name, value: selected ? selected.value : ""}});
  };

  const selectElement = options ? (
    <Select
      options={options}
      value={selectValue}
      onChange={handleSelectChange}
      isDisabled={disabled}
      isSearchable={true}
      placeholder="Selecione ou digite..."
      noOptionsMessage={() => "Nenhuma opção encontrada"}
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: '31px',
          height: '31px',
          fontSize: '14px',
          borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
          boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13,110,253,0.25)' : 'none',
          '&:hover': {borderColor: '#86b7fe'},
        }),
        valueContainer: (base) => ({...base, padding: '0 8px', height: '31px'}),
        indicatorsContainer: (base) => ({...base, height: '31px'}),
        dropdownIndicator: (base) => ({...base, padding: '4px'}),
        clearIndicator: (base) => ({...base, padding: '4px'}),
        menu: (base) => ({...base, fontSize: '14px', zIndex: 1000}),
      }}
    />
  ) : null;

  if (value || value === 0) {
    return (
      <OverlayTrigger
        placement={"bottom"}
        overlay={<Tooltip id={name}>{value}</Tooltip>}
      >
        <Col {...colProps}>
          <div className={`div-form-group ${disabled ? "" : "enabled"}`}>
            <Form.Group>
              <Form.Label>{label}</Form.Label>
              {type === "date" ? (
                <InputMask
                  {...props}
                  size="sm"
                  className={"form-control form-control-sm"}
                  onFocus={(e) => e.target.select()}
                  mask={"99/99/9999"}
                  name={name}
                  placeholder={value}
                  disabled={disabled}
                />
              ) : options ? selectElement : (
                <Form.Control
                  {...props}
                  disabled={disabled}
                  name={name}
                  value={value}
                  size="sm"
                  className="text-truncate"
                  onChange={onChange}
                />
              )}
            </Form.Group>
          </div>
        </Col>
      </OverlayTrigger>
    );
  }

  return (
    <Col {...colProps}>
      <div className={`div-form-group ${disabled ? "" : "enabled"}`}>
        <Form.Group>
          <Form.Label>{label}</Form.Label>
          {options ? selectElement : (
            <Form.Control
              {...props}
              disabled={disabled}
              name={name}
              value={value || ''}
              size="sm"
              className="text-truncate"
              onChange={onChange}
            />
          )}
        </Form.Group>
      </div>
    </Col>
  );
}

function ProcessInfos({
                        allCells,
                        allProcessType,
                        processType,
                        processTypeDisabled,
                        deadlineDisabled,
                        responsibleProcessDisabled,
                        allProcessStatus,
                        processStatus,
                        processStatusDisabled,
                        oneProcess,
                        responsibleProcess,
                        creatorCell,
                        retirementTypeId,
                        handleChangeRetirementType,
                        handleChangeProcessStatus,
                        handleChangeDeadline,
                        handleChangeProcessType,
                        handleChangeResponsibleProcess,
                        handleChangeResponsibleProcessUser,
                        handleCustomerProtocol,
                        listUsers,
                        responsibleUserId,
                        fileLocation,
                        handleChangeFileLocation
                      }) {
  const [contentVisible, setContentVisible] = React.useState(true);
  const [allRetirementType, setAllRetirementType] = React.useState([]);

  useEffect(() => {
    findAllRetirementType().then(({ok, data}) => {
      if (ok) setAllRetirementType(data.map(el => ({label: el.description, value: el.id})));
    });
  }, []);

  return (
    <Card className={genericStyles.cards}>
      <div>
        <div
          className={`clickable pt-3 mt-n3 px-3 mx-n3 d-flex justify-content-between header-card-hover ${contentVisible ? "pb-2" : "mb-n3 pb-3"}`}
          onClick={() => setContentVisible(!contentVisible)}
        >
          <span><strong>Dados do Andamento</strong></span>
          <i className={`fas fa-angle-down pl-2 navi-rotate-icon ${contentVisible ? "" : "navi-icon-right"}`}/>
        </div>
        {contentVisible ? (
          <div>
            <div className={"mb-2 border-top"}/>
            <Form.Row>
              <RenderInput colProps={{xs: "12", sm: "2"}} name="processId" label="ID" value={oneProcess.id} type="text" disabled/>
              <RenderInput colProps={{xs: "12", sm: "4", md: "3"}} name="customerId" label="ID DO CLIENTE" value={oneProcess.customer.id} type="text" disabled/>
              <RenderInput colProps={{xs: "12", sm: "6", md: "5"}} name="customerName" label="NOME DO CLIENTE" value={oneProcess.customer.name} type="text" disabled/>
              <RenderInput colProps={{xs: "12", sm: "3", md: "2"}} name="applicationProtocol" label="PROTOCOLO" value={oneProcess.applicationProtocol} type="text" onChange={handleCustomerProtocol} disabled={processStatusDisabled}/>
              <RenderInput colProps={{xs: "12", sm: "4", md: "4"}} name="createDate" label="DATA DE CRIAÇÃO" value={getFormattedDate(oneProcess.createDate)} type="text" disabled/>
              <RenderInput colProps={{xs: "12", sm: "5", md: "4"}} name="updateDate" label="PRAZO DE ENTREGA" value={oneProcess.paused ? "Processo pausado" : getFormattedDate(oneProcess.deliveryDate)} type={oneProcess.paused ? "text" : "date"} disabled={!oneProcess.paused && deadlineDisabled} onChange={handleChangeDeadline}/>
              <RenderInput colProps={{xs: "12", sm: "4", md: "4"}} name="applicationProtocol" label="DATA PROTOCOLO" value={oneProcess.protocolDate ? oneProcess.protocolDate.split("-").reverse().join("/") : 'Não Informado'} type="text" onChange={handleCustomerProtocol} disabled={processStatusDisabled}/>
              <RenderInput colProps={{xs: "12", md: "4"}} name="processType" label="TESE" value={processType} disabled={processTypeDisabled} onChange={handleChangeProcessType} options={allProcessType ? Object.keys(allProcessType).map((item) => ({value: item, label: item})) : null}/>
              <RenderInput colProps={{xs: "12", md: "4"}} name="processStatus" label="STATUS" value={processStatus} disabled={processStatusDisabled} onChange={handleChangeProcessStatus} options={allProcessStatus ? Object.keys(allProcessStatus).map((item) => ({value: item, label: item})) : null}/>
              <RenderInput colProps={{xs: "12", md: "4"}} name="retirementTypeId" label="TIPO DE APOSENTADORIA" value={retirementTypeId} disabled={processStatusDisabled} onChange={handleChangeRetirementType} options={allRetirementType}/>
              <RenderInput colProps={{xs: "12", md: "4"}} name="fileLocation" label="LOCALIZADOR DE ARQUIVO" value={fileLocation} type="text" onChange={handleChangeFileLocation} disabled={processStatusDisabled}/>
              <RenderInput colProps={{xs: "12", sm: "4", md: "4"}} name="owner" label="CÉLULA RESPONSÁVEL" value={responsibleProcess} disabled={responsibleProcessDisabled} onChange={handleChangeResponsibleProcess} options={allCells ? Object.keys(allCells).map((item) => ({value: item, label: item})) : null}/>
              <RenderInput colProps={{xs: "12", sm: "4", md: "4"}} name="creator" label="CÉLULA CRIADORA" value={creatorCell} disabled/>
              <RenderInput colProps={{xs: "12", sm: "4", md: "4"}} name="responsibleUserId" label="Responsável" value={responsibleUserId} disabled={responsibleProcessDisabled} onChange={handleChangeResponsibleProcessUser} options={listUsers.map(({id, name}) => ({value: id, label: name}))}/>
            </Form.Row>
          </div>
        ) : null}
      </div>
    </Card>
  );
}

export default ProcessInfos;
